var map = {
	"./1.png": 1941,
	"./10.png": 1942,
	"./2.png": 1943,
	"./3.png": 1944,
	"./4.png": 1945,
	"./5.png": 1946,
	"./6.png": 1947,
	"./7.png": 1948,
	"./8.png": 1949,
	"./9.png": 1950,
	"./maintop.png": 1337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1940;